import axios from "axios";
import API from "../helpers/api";
import moment from "moment";
import { getApplicableServiceTypeBudgetList } from "../Actions/helpersAPI";
import FileSaver from "file-saver";
let searchData = {
  Equipment: "",
  EquipmentType: "",
  Category: "",
  ServiceTypes: "",
  PageNumber: 1,
  PageSize: 20,
};

/* export const getEquipmentCyclingServiceYear = (id) => {

   let url = `${API.getEquipmentDetail}?shipid=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => { 
  dispatch({
    type: "getEquipmentCyclingServiceYearSuccess",
    data: [
      { id: 1, year: "1st year" },
      { id: 2, year: "2nd year" },
      { id: 3, year: "3rd year" },
      { id: 4, year: "4th year" },
      { id: 5, year: "5th year" },
    ],
  });
   })
      .catch((error) => {
        dispatch({
          type: "getEquipmentCyclingServiceYear",
          error: "ERROR",
        });
      }); 
  }
}; */

export const getEquipmentList = (item) => {
  //   if (item.ServiceTypes === undefined) {
  //     item.ServiceTypes = "";
  //   }

  let url = `${API.getEquipmentList}?EquipmentName=${item.Equipment}&EquipmentType=${item.EquipmentType}&Category=${item.Category}&capacity=${item.capacity}&MakeId=${item.MakeId}&ModelId=${item.ModelId}&ServiceTypeId=${item.ServiceTypeId}&EquipmentCategoryId=${item.EquipmentCategoryId}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getEquipmentDetails = (id) => {
  let url = `${API.getEquipmentDetail}?equipmentId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMakeAndModel = (id) => {
  let url = `${API.EquipmentNameAndId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentDropdownListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentDropdownListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getEquipmentMakeModelDetails = (id) => {
  let url = `${API.getEquipmentApplicableServices}?equipmentId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentMakeModelDetailsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentMakeModelDetailsFailure",
          error: "ERROR",
        });
      });
  };
};
export const getContractDetails = (id) => {
  let url = `${API.getPanelDetails}?shipId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getContractPanelDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getContractPanelDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const postEquipmentDetails = (data) => {
  let url = `${API.postEquipment}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch(getEquipmentList(searchData));
        dispatch({
          type: "postEquipmentDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postEquipmentDetailFailure",
          error: "ERROR",
        });
      });
  };
};
export const putEquipmentDetails = (data) => {
  let url = `${API.postEquipment}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch(getEquipmentList(searchData));
        dispatch({
          type: "putEquipmentDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putEquipmentDetailFailure",
          error: "ERROR",
        });
      });
  };
};
export const deleteEquipmentDetails = (data) => {
  let url = `${API.postEquipment}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch(getEquipmentList(searchData));
        dispatch({ type: "ShowSidePan", data: false });
        dispatch({
          type: "deleteEquipmentDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "deleteEquipmentDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentUsed = (id) => {
  let url = `${API.EquipmentUsed}?equipmentId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentUsedSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentUsedFailure",
          error: "ERROR",
        });
      });
  };
};
export const getEquipmentMakeModelAndType = (item) => {
  item.equipmentId = item.equipment ?? 0;
  item.makename = item.make ?? "";
  item.modelname = item.model ?? "";
  item.isBoth = item.isBoth ?? false;

  let url = `${API.getEquipmentMakeModelandType}?equipmentId=${item.equipmentId}&makename=${item.makename}&modelname=${item.modelname}&typeId=${item.typeId || 0}&isBoth=${item.isBoth}`;
  return async (dispatch) => {
    await axios
      .get(url)
      .then((response) => {
        if (
          item.equipmentId === 0 &&
          item.makename === "" &&
          item.modelname === ""
        ) {
          const uniqueIds = [];
          const unique = response.data.equipments.filter((element) => {
            const isDuplicate = uniqueIds.includes(element.name);
            if (!isDuplicate) {
              uniqueIds.push(element.name);
              return true;
            }
            return false;
          });

          dispatch({
            type: "getDropdownEquipmentNameListSuccess",
            data: unique,
          });
          dispatch({
            type: "getdropdownCategoryListSuccess",
            data: response.data.category,
          });
          dispatch({
            type: "getDropdownEquipmentTypeListSuccess",
            data: response.data.type,
          });
          dispatch({
            type: "getDropdownMakesListSuccess",
            data: response.data.make,
          });
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name,
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.equipmentId !== 0) {
          dispatch({
            type: "getdropdownCategoryListSuccess",
            data: response.data.category,
          });
          dispatch({
            type: "getDropdownEquipmentTypeListSuccess",
            data: response.data.type,
          });
          dispatch({
            type: "getDropdownMakesListSuccess",
            data: response.data.make,
          });
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.makename !== "" && item.modelname === "") {
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.modelname !== "") {
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.modelname !== "" && item.makename !== "") {
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.equipmentId !== 0 && item.makename !== "") {
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (
          item.equipmentId !== 0 &&
          item.makename !== "" &&
          item.modelname !== ""
        ) {
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "getShipPortAndCountryFailure",
          error: "ERROR",
        });
      });
  };
};

export const getShipEquipmentMakeModelAndType = (item) => {
  item.equipmentId = item.equipment ?? 0;
  item.makename = item.make ?? "";
  item.modelname = item.model ?? "";
  item.isBoth = item.isBoth ?? false;
  item.ShipEquipmentId = item.ShipEquipmentId ?? 0;

  let url = `${API.getShipEquipmentMakeModelandType}?shipId=${item.ShipEquipmentId}&equipmentId=${item.equipmentId}&makename=${item.makename}&modelname=${item.modelname}&typeId=${item.typeId || 0}&isBoth=${item.isBoth}`;
  return async (dispatch) => {
    await axios
      .get(url)
      .then((response) => {
        if (
          item.equipmentId === 0 &&
          item.makename === "" &&
          item.modelname === ""
        ) {
          const uniqueIds = [];
          const unique = response.data.equipments.filter((element) => {
            const isDuplicate = uniqueIds.includes(element.name);
            if (!isDuplicate) {
              uniqueIds.push(element.name);
              return true;
            }
            return false;
          });

          dispatch({
            type: "getDropdownEquipmentNameListSuccess",
            data: unique,
          });
          dispatch({
            type: "getdropdownCategoryListSuccess",
            data: response.data.category,
          });
          dispatch({
            type: "getDropdownEquipmentTypeListSuccess",
            data: response.data.type,
          });
          dispatch({
            type: "getDropdownMakesListSuccess",
            data: response.data.make,
          });
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name,
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.equipmentId !== 0) {
          dispatch({
            type: "getdropdownCategoryListSuccess",
            data: response.data.category,
          });
          dispatch({
            type: "getDropdownEquipmentTypeListSuccess",
            data: response.data.type,
          });
          dispatch({
            type: "getDropdownMakesListSuccess",
            data: response.data.make,
          });
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.makename !== "" && item.modelname === "") {
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.modelname !== "") {
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.modelname !== "" && item.makename !== "") {
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (item.equipmentId !== 0 && item.makename !== "") {
          dispatch({
            type: "getDropdownModelsListSuccess",
            data: response.data.model,
          });
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
        if (
          item.equipmentId !== 0 &&
          item.makename !== "" &&
          item.modelname !== ""
        ) {
          let list = [];
          let serviceTypeList = [];
          response.data.serviceTypes.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = (listItem[0]);
            let id = item.id;
            list.push({
              id,
              order,
            });
          });

          let mainList = list.sort(function (a, b) {
            return a.order - b.order;
          });
          mainList.map((item, i) => {
            let name = item.order + " yearly";
            item = item.id;
            serviceTypeList.push({
              item,
              name
            });
          });
          dispatch({
            type: "getDropdownApplicableSeviceTypeListSuccess",
            data: serviceTypeList,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "getShipPortAndCountryFailure",
          error: "ERROR",
        });
      });
  };
};

export const getEquipmentZoneList = () => {
  var zone = "zone";
  let url = `${API.lookupsearch}?LookUpToSearch=${zone}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getEquipmentZoneListSuccess",
          data: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "e",
          error: "ERROR",
        });
      });
  };
};

export const DownloadComplianceandBudgetList = (id, shipName, iscontract, isnotcontract, isboth) => {
  let url = `${API.downloadComplianceList}?shipId=${id}&inContract=${iscontract}&notInContract=${isnotcontract}&isBoth=${isboth}`;
  return (dispatch) => {
    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        let FileName = "Compliance" + " " + shipName + "_" + moment().format("DD MM YYYY LT") + ".xlsx";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob, FileName);
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "AttchmentUploadedFailure",
          error: "ERROR",
        });
      });
  };
};

/* export const getEquipmentServiceUpdateTypeList = (
  ShipId,
  ShipEquipId,
  EquipSerId
) => {
  let url = `${API.GetServiceRange}?shipId=${ShipId}&EquipmentServiceId=${EquipSerId}&ShipEquipmentId=${ShipEquipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if(response.data?.applicableServices && response.data?.applicableServices.length !==0){
        let data = {
          applicableServices: [
            {
              id: 24,
              name: "4 Yearly",
              range: "23/2/2020-23/2/2024",
            },
            {
              id: 22,
              name: "2 Yearly",
              range: "23/2/2020-23/2/2022",
            },
            {
              id: 21,
              name: "1 Yearly",
              range: "23/2/2020-23/2/2021",
            },

            {
              id: 23,
              name: "3 Yearly",
              range: "23/2/2020-23/2/2023",
            },
            {
              id: 25,
              name: "5 Yearly",
              range: "23/2/2020-23/2/2025",
            },
          ],
        }; 
        let list = [];
        let serviceTypeList = [];
        response.data.applicableServices.map((item, index) => {
            let listItem = item.name.split(" ");
            let order = parseInt(listItem[0]);
          let id = item.id;
          let range = item.range;
          list.push({
            id,
            order,
            range,
          });
        });
        console.log("finallist", list);
        let mainList = list.sort(function (a, b) {
          return a.order - b.order;
        });
        mainList.map((item, i) => {
          let name = item.order + " yearly";
          let listItem1 = item.range.split("-");
          let order = listItem1[0].substring(listItem1[0].lastIndexOf("/") + 1);
          let order1 = listItem1[1].substring(
            listItem1[1].lastIndexOf("/") + 1
          );
          let finalyear = order + " - " + order1;
         let id = item.id;
          let range = item.range;
          serviceTypeList.push({
            id,
            name,
            range,
            finalyear,
          });
        });
        console.log("YearResult",serviceTypeList)
        dispatch({
          type: "getEquipmentServiceUpdateTypeListSuccess",
          data: serviceTypeList,
        });
      }
        else{
          dispatch({
            type: "getEquipmentServiceUpdateTypeListSuccess",
            data: response.data.applicableServices,
          }); 
        }
      })
      .catch((error) => {
        dispatch({
          type: "getEquipmentServiceUpdateTypeListFailure",
          error: "ERROR",
        });
      });
  };
};
 */